var exports = {
  "kL": "TabDisguiseSection.module__container___clFoWm",
  "VB": "TabDisguiseSection.module__customFields___clFoWm",
  "rT": "TabDisguiseSection.module__previewRow___clFoWm",
  "mP": "TabDisguiseSection.module__previewIcon___clFoWm",
  "Vf": "TabDisguiseSection.module__previewTitle___clFoWm",
};

module.exports = exports;
